module.exports = __webpack_public_path__ + "img/系统版本.02943a47.jpg";